module.exports = __webpack_public_path__ + "static/img/manual_zh_33.f6be8ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_33.png
// module id = YEjW
// module chunks = 4